import { HighlightTextWebElementBase } from './HighlightTextWebElementBase';

/**
 * The component WebElement for [oj-c-highlight-text](../../jsdocs/oj-c.HighlightText.html).
 * Do not instantiate this class directly, instead, use
 * [findHighlightText](../functions/findHighlightText.html).
 */
export class HighlightTextWebElement extends HighlightTextWebElementBase {
  // Put overrides here
}
